import React from 'react';
import { AppBar as MuiAppBar } from '@material-ui/core';

const AppBar = props => <MuiAppBar {...props} />;

export default AppBar;
